<template>
  <div class="main-div">
    <h1>Payment Successful</h1>
  </div>
</template>

<script setup>
import {
  onMounted, onUnmounted, ref, nextTick, computed,
} from 'vue';
import { useRouter } from 'vue-router';

import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

onMounted(() => {
  SessionSuccessHandler() 
});

async function  SessionSuccessHandler() {

  const dsConn = new DatastoreConnect();

  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  if( urlParams.has('session_id') ){
    const sessionID = urlParams.get('session_id');
    console.log(sessionID)
    const ret = await dsConn.paymentSessionSuccess({session_id:  sessionID  });


     if (ret.result) {
        // const url = ret.result["url"];
        // if (url.includes("admin/payment_success")) {
        //   $toast.open({
        //     queue: true,
        //     dismissible: true,
        //     message: `Successfully updated plan`,
        //     type: "success",
        //     position: "top",
        //   });
        //   this.refreshPage();
        // } else if (url.includes("admin/payment_fail")) {
        //   $toast.open({
        //     queue: true,
        //     dismissible: true,
        //     message: `Error changing plan`,
        //     type: "error",
        //     position: "top",
        //   });
        // } else {
        //   window.location.replace(url);
        // }
    }

  }
      

 
  } 



</script>

<style lang="scss" scoped>

a {
  text-decoration: none;
    color:#dfe0e0;
}

.main-div {
  margin: 20px;

}

.plan_name {
  font-style: italic;
}

.link-button {
  background: #0c396d;
  width: 220px;
  padding: 8px;
  border: solid;
  border-radius: 6px;
  color: white;
  text-align: center;
  cursor: pointer;
}

.link-button:hover {
  background:  #092145;

}

</style>
